import { Button, Input, Select } from 'antd';
import React, { useEffect, useRef } from 'react';
import { StringComparisons } from '../../../Networking';
import { Box } from '../../Box/Box';
import { Stack } from '../../Stack';
import { CheckOutlined, DeleteFilled } from '@ant-design/icons';
import styles from './Filters.module.css';
import { TableFilterProps } from '../interfaces';

interface IProps extends TableFilterProps {}

const filterComparisons: { comp: StringComparisons; name: string }[] = [
  { comp: 'contains', name: 'Contains' },
  { comp: 'startsWith', name: 'Starts With' },
  { comp: 'endsWith', name: 'Ends With' },
  { comp: 'equals', name: 'Equals' },
];

export const StringTableFilter: React.FC<IProps> = ({
  filters,
  setFilters: setFilter,
  onClear,
  onConfirm,
  visible,
}) => {
  const { comparison, value } =
    filters.length != 0
      ? filters[0]
      : { comparison: undefined, value: undefined };
  if (value !== undefined && typeof value !== 'string') {
    throw new Error('Should this be an error? Expected a string');
  }

  const inputRef = useRef<React.ElementRef<typeof Input>>(null);

  useEffect(() => {
    if (visible) {
      setTimeout(() => inputRef.current?.focus(), 500);
    }
  }, [visible]);

  return (
    <Box padding="sm">
      <Stack alignment="middle" gap={10} stretch>
        <Box width={170}>
          <Stack direction="vertical" gap={5}>
            <Select
              value={comparison ?? 'contains'}
              onChange={(f) =>
                setFilter([{ comparison: f, value: value ?? '' }])
              }
              className={styles.fullWidth}
            >
              {filterComparisons.map((c) => (
                <Select.Option key={c.comp} value={c.comp}>
                  {c.name}
                </Select.Option>
              ))}
            </Select>
            <Input.Search
              ref={inputRef}
              value={value}
              placeholder="Filter"
              onChange={(v) =>
                setFilter([
                  {
                    comparison: comparison ?? 'contains',
                    value: v.currentTarget.value,
                  },
                ])
              }
              onPressEnter={onConfirm}
              onSearch={onConfirm}
              className={styles.fullWidth}
              enterButton={<CheckOutlined />}
            />
          </Stack>
        </Box>

        <Stack direction="vertical" gap={5}>
          <Button
            type="primary"
            danger
            icon={<DeleteFilled />}
            onClick={onClear}
          />
        </Stack>
      </Stack>
    </Box>
  );
};

StringTableFilter.displayName = 'StringTableFilter';
export default StringTableFilter;
